module.exports = __webpack_public_path__ + "img/banner2.19b1fcd1.png";